export const formatDist = (number) =>
  new Intl.NumberFormat("de-DE", {
    style: "decimal",
  }).format(Math.round(number * 100) / 100) + "km";

export const camelize = (str) => {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};
